import { Popover, Button, Box, Typography, TextField, IconButton, Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

export function SetNewPasswordPopover(props) {

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');

    let maxWidth = window.innerWidth * 0.5; // half the window, up to 700
    if (maxWidth > 700) 
        maxWidth = 700;

    const onClose = () => {
        setPassword('');
        setConfirmPassword('');
        setError('');
        props.closeCallback();
    };

    const onOk = () => {

        const passwordRequirements = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/; // At least 8 characters, one lowercase, one uppercase, one number

        if (!passwordRequirements.test(password)) {
            setError('Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one number');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        setError('');
        props.okCallback(password); // Pass the chosen password to the callback
        setPassword('');
        setConfirmPassword('');
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <Popover
            open={props.isOpen}
            anchorReference="anchorPosition"
            anchorPosition={{ left: window.innerWidth / 2, top: window.innerHeight / 2 }}
            transformOrigin={{ vertical: 'center', horizontal: 'center' }}
        >
            <Box style={{ margin: 20, width: maxWidth }}>
                <Typography variant="h6" style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 30 }}>
                    Change Password for {props.user ? props.user.fullName() : ''}
                </Typography>

                <TextField
                    label="New Password"
                    variant="outlined" InputLabelProps={{ shrink: true}}
                    type={showPassword ? 'text' : 'password'}
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ marginBottom: 20, fontFamily: 'monospace' }}
                    InputProps={{
                        endAdornment: (
                            <Tooltip title={showPassword ? "Hide Password" : "Show Password"}>
                                <IconButton onClick={toggleShowPassword}>
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </Tooltip>
                        ),
                    }}
                />

                <TextField
                    label="Confirm Password"
                    variant="outlined" InputLabelProps={{ shrink: true}}
                    type={showPassword ? 'text' : 'password'}
                    fullWidth
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={{ marginBottom: 20, fontFamily: 'monospace' }}
                />

                {error && (
                    <Typography variant="body2" style={{ color: 'red', marginBottom: 20 }}>
                        {error}
                    </Typography>
                )}

                <Box style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
                    <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={onOk} variant="outlined" color="primary">
                        OK
                    </Button>
                </Box>
            </Box>
        </Popover>
    );
}